/** @format */

// @ts-ignore
import { download, post } from '@root/utils/httpWrap';

interface Ibase {
  userId: string;
  parkId?: string;
  organId?: string;
  chkDayStart?: string;
  chkDayEnd?: string;
  result?: string;
  status?: string;
  currPage?: string | number;
  pageSize?: string | number;
}

export interface Ilocalcash extends Ibase {
  status?: string;
}

/**
 * 本地收费对账
 */
export const localcashList = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/localcash', params);
};

/**
 * 本地收费对账
 */

export const exportLocalcashExport = (params: any, flieName?: string): any => {
  return download('/bangdao/saasapi/v1/check/localcashExport', params, flieName);
};

export interface IlocalcashDetail extends Ibase {
  platformTradeNo?: string;
  localTradeNo?: string;
}

/**
 * 本地明细对账
 */
export const localcashDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/localcashDetail', params);
};

/**
 * 本地明细对账导出
 */
export const exportLocalcashDetailExport = (params: any, flieName?: string): any => {
  return download('/bangdao/saasapi/v1/check/localcashDetailExport', params, flieName);
};

export interface Ithirdpay extends Ibase {
  thirdPlatform?: string;
  checkType?: string;
}

/**
 * 线上支付对账
 */
export const thirdpay = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/thirdpay', params);
};

export interface IthirdpayDetail extends Ibase {
  thirdPlatform?: string;
  plateformTradeNo?: string;
  thirdTradeNo?: string;
}

/**
 * 线上支付对账 导出
 */

export const exportThirdpayExport = (params: any, flieName?: string): any => {
  return download('/bangdao/saasapi/v1/check/thirdpayExport', params, flieName);
};

/**
 * 线上明细对账
 */
export const thirdpayDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/thirdpayDetail', params);
};

/**
 * 线上明细对账 导出
 */
export const exportThirdpayDetailExport = (params: any, flieName?: string): any => {
  return download('/bangdao/saasapi/v1/check/thirdpayDetailExport', params, flieName);
};

/**
 * 异常收入账单
 */

export interface IoexceptionOrderValue extends Ibase {
  status?: string;
}

export const oexceptionOrder = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/exceptionOrder', params);
};

/**
 * 异常收入 导出
 */

export const exportExceptionOrderExport = (params: any, flieName?: string): any => {
  return download('/bangdao/saasapi/v1/check/exceptionOrderExport', params, flieName);
};

/**
 * 存现单分页查询接口
 * @param params
 */
export const getDepositOfCashPageList = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/getDepositOfCashPageList', params);
};

/**
 * 存现单添加缴费记录查询
 * @param params
 */
export const getEasPayRecordPageList = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/getEasPayRecordPageList', params);
};

/**
 * 存现单冲销接口
 * @param params
 */
export const cancelDepositOfCash = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/cancelDepositOfCash', params);
};

/**
 * 缴费记录分页查询
 * @param params
 */
export const getDepositDetailPageListById = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/getDepositDetailPageListById', params);
};

/**
 * 查询银行信息列表
 * @param params
 */
export const getBankInfokList = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/getBankInfokList', params);
};

/**
 * 上传
 * @param params
 */
export const upload = (params: FormData): any => {
  return post('/bangdao/saasapi/v1/check/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 存现单新增
 * @param params
 */
export const addDepositOfCash = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/addDepositOfCash', params);
};
/**
 * 线上支付下账
 * @param params
 */
export const downAccount = (params: any): any => {
  return post('/bangdao/saasapi/v1/check/downAccount', params);
};
